import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {EntityWithAuditMetadata} from "../../../../../common/entity/entityWithAuditMetadata";

export class CamJobSummaryModel extends EntityWithAuditMetadata {
    id: number;
    permissions: PermissionsModel;
    item: string;
    side: LovValueSummary;
}
